/* eslint-disable @typescript-eslint/no-explicit-any */
import { isEqual } from 'lodash';
import { rmsSupportCenterTypes } from '../reduxExports';
import rmsStore from '../rmsStore';
import { isAxiosError } from 'axios';
import hwaxios from '../api-service/HWAxios';
import { articlesPathMap } from '../../components/rmsSupportCenter/helpAndFAQ/HelpAndFAQArticle';

const url = process.env.REACT_APP_SERVER_BASE_URL;
const availableArticles = Object.keys(articlesPathMap);

export const fetchRmsSupportSearchQueryMatchingPrompts: any =
  (reqBody) =>
    async (dispatch): Promise<void> => {
      try {
        const searchHash = reqBody?.queryText && reqBody.queryText.trim() !== ''
          ? reqBody.queryText.trim() : null;

        const hashAction: Partial<RmsSupportCenterAction> = {
          type: rmsSupportCenterTypes.SET_RMS_SUPPORT_SEARCH_QUERY_MATCHING_PROMPTS_SEARCH_HASH,
          rmsSupportSearchQueryMatchingPromptsSearchHash: searchHash
        };
        dispatch(hashAction);

        const response = await hwaxios.post(url + '/rms-support-center/searches', reqBody)

        const prompts = response?.data?.data?.map(item=>{
          return {
            id: item?.title?.toLowerCase(),
            value: item?.title?.toLowerCase()
          }
        })

        if (
          searchHash === rmsStore.getState().rmsSupportCenterReducer.rmsSupportSearchQueryMatchingPromptsSearchHash
        ) {
          const action = {
            type: rmsSupportCenterTypes.FETCH_RMS_SUPPORT_AI_CHATBOT_SEARCH_QUERY_MATCHING_PROMPTS,
            rmsSupportSearchQueryMatchingPrompts: prompts
          };
          dispatch(action);
        }
      } catch (error) {
        console.error(error);
        throw error;
      }
    };


export const fetchRmsSupportSearchQueryResponse: any =
  (reqBody) =>
    async (dispatch): Promise<void> => {
      try {
        const loaderStartAction: Partial<RmsSupportCenterAction> = {
          type: rmsSupportCenterTypes.SET_RMS_SUPPORT_SEARCH_QUERY_RESPONSE_LOADER,
          rmsSupportSearchQueryResponseLoader: true,
          rmsSupportSearchQuery: reqBody.query
        };
        dispatch(loaderStartAction);

        const searchHash = reqBody?.queryText && reqBody.queryText.trim() !== ''
          ? reqBody.queryText.trim() : null;

        const hashAction: Partial<RmsSupportCenterAction> = {
          type: rmsSupportCenterTypes.SET_RMS_SUPPORT_SEARCH_QUERY_RESPONSE_SEARCH_HASH,
          rmsSupportSearchQueryResponseSearchHash: searchHash
        };
        dispatch(hashAction);

        const response = await hwaxios.post(url + '/rms-support-center', reqBody)
        // const response = {
        //   status: 200,
        //   data: {
        //         summary: 'This feature is under development.',
        //         relatedTopics: [] as {[key:string]:string}[]
        //   }
        // }

        const result = [
          {
            id:'random-text-id'+reqBody?.query,
            query: reqBody?.query,
            result: {
              text: response?.data?.summary,
              links: response?.data?.relatedTopics.length > 0 ? response?.data?.relatedTopics
              ?.filter(topic => topic  && availableArticles?.includes(topic?.title?.toLowerCase()?.split(' ')?.join('-')))?.map(topic=>{
                return {
                  label:topic?.title,
                  href:`/help-and-faq/chargers?article=${topic?.title?.toLowerCase()?.split(' ')?.join('-')}`
                }
              }) : [] 
            }
          }
        ]

        if (
          searchHash === rmsStore.getState()?.rmsSupportCenterReducer?.rmsSupportSearchQueryResponseSearchHash
        ) {
          const action = {
            type: rmsSupportCenterTypes.FETCH_RMS_SUPPORT_SEARCH_QUERY_RESPONSE,
            rmsSupportSearchQueryResponse: result
          };
          dispatch(action);
        }

        if (response?.status === 200) {
          const loaderEndAction: Partial<RmsSupportCenterAction> = {
            type: rmsSupportCenterTypes.SET_RMS_SUPPORT_SEARCH_QUERY_RESPONSE_LOADER,
            rmsSupportSearchQueryResponseLoader: false,
            rmsSupportSearchQuery: null
          };
          dispatch(loaderEndAction);
        }
      } catch (error) {
        const loaderEndAction: Partial<RmsSupportCenterAction> = {
          type: rmsSupportCenterTypes.SET_RMS_SUPPORT_SEARCH_QUERY_RESPONSE_LOADER,
          rmsSupportSearchQueryResponseLoader: false,
          rmsSupportSearchQuery: null
        };
        dispatch(loaderEndAction);
        console.error(error);
        throw error;
      }
    };

// const sleep = (ms)=>{
//   return new Promise(resolve=>setTimeout(resolve,ms))
// }

export const fetchTroubleshootingListData : any =
  (reqBody) =>
    async (dispatch): Promise<void> => {
      try{
        const loaderStartAction: Partial<RmsSupportCenterAction> = {
          type: rmsSupportCenterTypes.SET_RMS_SUPPORT_TROUBLESHOOTING_LIST_LOADER,
          rmsSupportTroubleshootingListLoader: true
        }

        dispatch(loaderStartAction);
        
        const searchHash = reqBody?.searchTerm && reqBody.searchTerm.trim() !== ''
          ? reqBody.searchTerm.trim() : null;

        const filterHash = reqBody?.filters;

        const hashAction: Partial<RmsSupportCenterAction> = {
          type: rmsSupportCenterTypes.SET_RMS_SUPPORT_TROUBLESHOOTING_LIST_REQUEST_HASH,
          rmsSupportTroubleshootingSearchHash: searchHash,
          rmsSupportTroubleshootingFilterHash: filterHash
        };
        dispatch(hashAction);

        const response = await hwaxios.post(url + '/rms-support-center/troubleshooting/list', reqBody)

        if (
          searchHash === rmsStore.getState().rmsSupportCenterReducer.rmsSupportTroubleshootingSearchHash &&
          isEqual(filterHash, rmsStore.getState().rmsSupportCenterReducer.rmsSupportTroubleshootingFilterHash)
        ) {
          if (
            reqBody?.fetchType === 'alarm'
          ){
            const action = {
              type: rmsSupportCenterTypes.FETCH_RMS_SUPPORT_TROUBLESHOOTING_ALARM_LIST,
              rmsSupportTroubleshootingAlarmList: response.data?.data?.troubleshootingList,
              rmsSupportTroubleshootingAlarmListCount: response.data?.data?.troubleshootingListCount,
            };
            dispatch(action);
          }else {
            const action = {
              type: rmsSupportCenterTypes.FETCH_RMS_SUPPORT_TROUBLESHOOTING_STOP_REASON_LIST,
              rmsSupportTroubleshootingStopReasonList: response.data?.data?.troubleshootingList,
              rmsSupportTroubleshootingStopReasonListCount: response.data?.data?.troubleshootingListCount,
            };
            dispatch(action);
          }
        }

        if (response?.status === 200) {
          const loaderEndAction: Partial<RmsSupportCenterAction> = {
            type: rmsSupportCenterTypes.SET_RMS_SUPPORT_TROUBLESHOOTING_LIST_LOADER,
            rmsSupportTroubleshootingListLoader: false
          }
          dispatch(loaderEndAction);
        }

      }catch (error) {
        const loaderEndAction: Partial<RmsSupportCenterAction> = {
          type: rmsSupportCenterTypes.SET_RMS_SUPPORT_TROUBLESHOOTING_LIST_LOADER,
          rmsSupportTroubleshootingListLoader: false
        }
        dispatch(loaderEndAction);
        console.error(error);
        throw error;
      }

    }


export const setRmsTroubleshootingAlarmTableProps: any = (data) => async (dispatch: (arg0: Partial<RmsSupportCenterAction>) => void): Promise<void> => {
  const action = {
    type: rmsSupportCenterTypes.SET_RMS_SUPPORT_TROUBLESHOOTING_ALARM_TABLE_PROPS,
    rmsSupportTroubleshootingAlarmTableProps: data,
  };
  dispatch(action);
};

export const setRmsTroubleshootingStopReasonTableProps: any = (data) => async (dispatch: (arg0: Partial<RmsSupportCenterAction>) => void): Promise<void> => {
  const action = {
    type: rmsSupportCenterTypes.SET_RMS_SUPPORT_TROUBLESHOOTING_STOP_REASON_TABLE_PROPS,
    rmsSupportTroubleshootingStopReasonTableProps: data,
  };
  dispatch(action);
};

export const setRmsSupportDocumentationTableProps: any = (data) => async (dispatch: (arg0: Partial<RmsSupportCenterAction>) => void): Promise<void> => {
  const action = {
    type: rmsSupportCenterTypes.SET_RMS_SUPPORT_DOCUMENTATION_TABLE_PROPS,
    rmsSupportDocumentationTableProps: data,
  };
  dispatch(action);
};

export const fetchRmsSupportDocumentationListData : any =
  (reqBody) =>
    async (dispatch): Promise<void> => {
      try {

        const loaderStartAction: Partial<RmsSupportCenterAction> = {
          type: rmsSupportCenterTypes.SET_RMS_SUPPORT_DOCUMENTATION_TABLE_LIST_LOADER,
          rmsSupportDocumentationListLoader: true
        }

        dispatch(loaderStartAction);

        const searchHash = reqBody?.searchTerm && reqBody.searchTerm.trim() !== ''
          ? reqBody.searchTerm.trim() : null;

        const filterHash = reqBody?.filters;

        const hashAction: Partial<RmsSupportCenterAction> = {
          type: rmsSupportCenterTypes.SET_RMS_SUPPORT_DOCUMENTATION_TABLE_LIST_REQUEST_HASH,
          rmsSupportDocumentationSearchHash: searchHash,
          rmsSupportDocumentationFilterHash: filterHash
        }

        dispatch(hashAction);

        const response = await hwaxios.post(url + '/rms-support-center/documentation/list', reqBody)
        
        if(
          searchHash === rmsStore.getState().rmsSupportCenterReducer.rmsSupportDocumentationSearchHash && 
          isEqual(filterHash,rmsStore.getState().rmsSupportCenterReducer.rmsSupportDocumentationFilterHash)
        ) {
          const action: Partial<RmsSupportCenterAction> = {
            type: rmsSupportCenterTypes.FETCH_RMS_SUPPORT_DOCUMENTATION_LIST,
            rmsSupportDocumentationList: response?.data?.data?.documentsList,
            rmsSupportDocumentationListCount: response?.data?.data?.documentsListCount
          }

          dispatch(action);
        }

        if ( response?.status === 200 ) {
          const loaderEndAction: Partial<RmsSupportCenterAction> = {
            type: rmsSupportCenterTypes.SET_RMS_SUPPORT_DOCUMENTATION_TABLE_LIST_LOADER,
            rmsSupportDocumentationListLoader: false
          }
          dispatch(loaderEndAction);
        }

      } catch ( error ) {
        const loaderEndAction: Partial<RmsSupportCenterAction> = {
          type: rmsSupportCenterTypes.SET_RMS_SUPPORT_DOCUMENTATION_TABLE_LIST_LOADER,
          rmsSupportDocumentationListLoader: false
        }
        dispatch(loaderEndAction);
        console.error(error);
        throw error;
      }
    }


export const createRmsSupportDocument: any = (reqBody) => async () => {
  try {
    const { data, status } = await hwaxios.post(url + '/rms-support-center/documentation', reqBody);
    return { data, status };
  } catch (error) {
    if (isAxiosError(error)) {
      if (error.response) {
        const data = error.response.data;
        const status = error.response.status;
        return { data, status };
      }
    } else {
      return {
        data: 'Something went wrong', status: 400
      };
    }
  }
}